import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function TopHeader({ profile }) {
  const navigate = useNavigate();

  return (
    <div className="flex justify-between items-center px-5 py-3 bg-[var(--background)] shadow-sm">

      {/* BACK BUTTON */}
      <button
        onClick={() => navigate(-1)}
        className="p-2 rounded-lg border-2 border-[var(--hover)] transition"
      >
        <ArrowLeft className="w-5 h-5 text-[var(--subtext)]" />
      </button>

      {/* CENTER TEXT */}
      <div className="flex flex-col items-center text-center select-none">

        {/* Main Title */}
        <div className="text-[var(--text)] font-semibold text-base">
          PROFILE
        </div>

        {/* Balance & Profit Loss */}
        <div className="flex gap-3 mt-1">
          {/* Profit / Loss */}
          <span
            className={`text-sm font-semibold ${
              profile.profit_loss >= 0
                ? "text-[var(--buymeta)]"
                : "text-[var(--sellmeta)]"
            }`}
          >
            P/L: {Number(profile.profit_loss).toLocaleString("en-IN")}
          </span>

        </div>
      </div>

      {/* EMPTY BUTTON (symmetry) */}
      <button
        className="p-2 rounded-lg border border-[var(--background)] transition relative"
      >
        <ArrowLeft className="w-5 h-5 text-[var(--background)]" />
      </button>
    </div>
  );
}
